var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF9E00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.707 15c0 1.493-1.214 2.707-2.707 2.707-1.493 0-2.707-1.214-2.707-2.707 0-1.493 1.214-2.707 2.707-2.707 1.493 0 2.707 1.214 2.707 2.707M15 6c-4.963 0-9 4.037-9 9s4.037 9 9 9c1.818 0 3.571-.541 5.07-1.565l.025-.018-1.212-1.41-.02.013c-1.154.743-2.49 1.135-3.863 1.135-3.945 0-7.155-3.21-7.155-7.155 0-3.945 3.21-7.155 7.155-7.155 3.945 0 7.155 3.21 7.155 7.155 0 .511-.057 1.029-.168 1.538-.227.929-.877 1.213-1.365 1.175-.491-.04-1.066-.39-1.07-1.245V15c0-2.51-2.042-4.552-4.552-4.552S10.448 12.49 10.448 15 12.49 19.552 15 19.552c1.22 0 2.363-.476 3.225-1.343.502.78 1.319 1.27 2.249 1.344.08.006.161.01.242.01.655 0 1.303-.22 1.827-.616.539-.41.942-1.003 1.165-1.714.035-.115.1-.378.1-.38l.002-.01c.132-.57.19-1.14.19-1.843 0-4.963-4.037-9-9-9",
    transform: "translate(-202 -158) translate(196 152)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailru);
export default __webpack_public_path__ + "static/media/mailru.7e6026e435ee1e52b3ba7c5d474f0879.svg";
export { ForwardRef as ReactComponent };